export const unsavedDrafts = new Map();
// Each question has its own record: editing another tab cannot replace the whole lab.
export const draftPrefix = (labId) => `chem-lab-skills:drafts:v1:${encodeURIComponent(labId)}:`;
export const draftKey = (labId, questionId) => `${draftPrefix(labId)}${questionId}`;
export function parseDraft(raw) {
  if (raw === null) return undefined;
  const record = JSON.parse(raw);
  const answer = record?.currentAnswer;
  if (record?.version !== 1 || !(typeof answer === 'string' || (Array.isArray(answer) && answer.every(x => typeof x === 'string')))
    || typeof record.isChecked !== 'boolean' || typeof record.isCorrect !== 'boolean') {
    throw new Error('Invalid draft record');
  }
  return record;
}
export function readDrafts(labId) {
  const answers = {};
  let error = '';
  try {
    const prefix = draftPrefix(labId);
    for (let i = 0; i < window.localStorage.length; i++) {
      const key = window.localStorage.key(i);
      if (!key?.startsWith(prefix)) continue;
      try { answers[key.slice(prefix.length)] = parseDraft(window.localStorage.getItem(key)); }
      catch { error = 'Some saved answers could not be restored. Their stored copies have been kept; check your work before editing them.'; }
    }
  } catch { error = 'Browser saving is unavailable. Keep this page open and copy your answers before leaving.'; }
  const pending = unsavedDrafts.get(labId);
  if (pending?.size) {
    Object.assign(answers, Object.fromEntries(pending));
    error = 'Some answers are not saved in this browser. Keep this page open and copy your answers before leaving.';
  }
  return { answers, error };
}
